export const schemaFieldRefPrefix = 'field';

export const fieldHighlightMatchToken = 'formula-custom-field-match';
export const functionHighlightMatchToken = 'formula-custom-function';

export const customCommands = {
  fieldsDotCommand: 'fieldsDotCommand',
} as const;
